export default __webpack_public_path__ + "static/8-8775b860b4c9d7953cf76257d085e471.webp";